import { SubjectDesign } from '../shared/SubjectContent.types';

// Figma 최종 분리파일 및 2026-10-23 검수 반영. 좌표는 GNB 125px을 제외한 본문 기준.
export const finalDesign: SubjectDesign = {
    height: 11200,
    backgrounds: [
        {
            top: 8641,
            height: 2557,
            color: '#f3f3f3',
        },
        {
            top: 6227,
            height: 2414,
            color: '#f3f3f3',
        },
        {
            top: 5149,
            height: 638,
            file: 'backdrop-5276.png',
        },
        {
            top: 2437,
            height: 2712,
            color: '#ffffff',
        },
        {
            top: 2047,
            height: 390,
            color: '#00c5bd',
        },
        {
            top: 1127.5,
            height: 919.5,
            color: '#eefffe',
        },
        {
            top: 809,
            height: 318,
            color: '#00c5bd',
        },
        {
            top: 0,
            height: 810,
            file: 'backdrop-125.png',
        },
    ],
    artworks: [
        {
            top: 0,
            left: 0,
            width: 1260,
            height: 810,
            file: 'section-0.webp',
            alt: '수학 학습 어린이와 윙크 학습기',
        },
        {
            top: 1127.5,
            left: 0,
            width: 1260,
            height: 921,
            file: 'section-1.webp',
            alt: '수학 학습 영역 안내',
            clipBottom: 1.5,
        },
        {
            top: 2047,
            left: 0,
            width: 1260,
            height: 390,
            file: 'section-2.webp',
            alt: '수학 학습 4단계 흐름',
        },
        {
            top: 2437,
            left: 0,
            width: 1260,
            height: 2712,
            file: 'section-3.webp',
            alt: '수학 학습 콘텐츠 예시',
        },
        {
            top: 5149,
            left: 0,
            width: 1260,
            height: 638,
            file: 'section-4.webp',
            alt: '수학 학습 효과 안내',
        },
        {
            top: 5787,
            left: -650,
            width: 2560,
            height: 440,
            file: 'section-5.webp',
            alt: '수학 단계별 커리큘럼',
        },
        {
            top: 6226,
            left: 0,
            width: 1260,
            height: 2414,
            file: 'section-6.webp',
            alt: '안녕 수학부터 수학 2단계 학습 예시',
        },
        {
            top: 8641,
            left: 0,
            width: 1260,
            height: 2557,
            file: 'section-7.webp',
            alt: '수학 3~5단계 학습 예시',
        },
    ],
    sections: [
        {
            key: 'contents_0(메인)',
            top: 0,
            height: 810,
        },
        {
            key: 'contents_1',
            top: 809,
            height: 1238,
        },
        {
            key: 'contents_2',
            top: 2047,
            height: 390,
            groups: [
                {
                    kind: 'list',
                    label: '수학·연산 학습 4단계',
                    items: [['2019:1309'], ['2019:1310'], ['2019:1311'], ['2019:1312']],
                },
            ],
        },
        {
            key: 'contents_3',
            top: 2437,
            height: 2712,
        },
        {
            key: 'contents_4',
            top: 5149,
            height: 638,
        },
        {
            key: 'contents_5',
            top: 5787,
            height: 440,
            groups: [
                {
                    kind: 'list',
                    label: '수학·연산 수준별 6개 과정',
                    items: [
                        ['2019:1256', '2019:1248', '2019:1249'],
                        ['2019:1255', '2019:1239', '2019:1238'],
                        ['2019:1254', '2019:1241', '2019:1240'],
                        ['2019:1253', '2019:1243', '2019:1242'],
                        ['2019:1252', '2019:1245', '2019:1244'],
                        ['2019:1251', '2019:1247', '2019:1246'],
                    ],
                },
            ],
        },
        {
            key: 'contents_6',
            top: 6227,
            height: 2414,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:1229',
                    keys: ['2019:1229', '2019:1230', '2019:1231', '2019:1232', '2019:1233'],
                },
                {
                    kind: 'course',
                    heading: '2019:1225',
                    keys: ['2019:1225', '2019:1226', '2019:1222', '2019:1220', '2019:1221'],
                },
                {
                    kind: 'course',
                    heading: '2019:1214',
                    keys: ['2019:1214', '2019:1215', '2019:1219', '2019:1216', '2019:1217', '2019:1218'],
                },
            ],
        },
        {
            key: 'contens_7',
            top: 8641,
            height: 2557,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:1203',
                    keys: ['2019:1203', '2019:1204', '2019:1200', '2019:1197', '2019:1198', '2019:1199'],
                },
                {
                    kind: 'course',
                    heading: '2019:1190',
                    keys: ['2019:1190', '2019:1191', '2019:1192', '2019:1193', '2019:1194', '2019:1195'],
                },
                {
                    kind: 'course',
                    heading: '2019:1184',
                    keys: ['2019:1184', '2019:1185', '2019:1186', '2019:1187'],
                },
            ],
        },
    ],
    texts: [
        {
            key: '2019:1344',
            tag: 'p',
            left: 79.5,
            top: 272,
            width: 39,
            height: 28,
            lineHeight: 28,
            letterSpacing: '0.1em',
            runs: [
                {
                    text: '수학        ',
                    left: 0.215,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:1346',
            tag: 'h1',
            left: 47,
            top: 320.5,
            width: 515,
            height: 225,
            lineHeight: 75,
            runs: [
                {
                    text: '즐겁게 시작한 수학,',
                    left: 0,
                    top: 0,
                },
                {
                    text: '스스로 해결하는 힘이 ',
                    left: 0,
                    top: 75,
                },
                {
                    text: '자랍니다',
                    left: 0,
                    top: 150,
                },
            ],
            font: 'Paperlogy',
            size: 60,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1336',
            tag: 'p',
            left: 372,
            top: 880,
            width: 518,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '문제만 많이 푼다고 수학의 기초가 쌓일까요?',
                    left: 0.07,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 600,
            color: 'white',
        },
        {
            key: '2019:1337',
            tag: 'h2',
            left: 306,
            top: 938,
            width: 650,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '수학 6대 영역을 놀이처럼 배우고',
                    left: 0.391,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1338',
            tag: 'h2',
            left: 230,
            top: 1003,
            width: 803,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '탄탄한 기초부터 빈틈없이 쌓는 ',
                    left: 0.084,
                    top: 0,
                },
                {
                    text: '윙크 수학',
                    color: '#FFF345',
                    left: 615.95,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1320',
            tag: 'h2',
            left: 365,
            top: 1215,
            width: 535,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '수학∙연산 ',
                    color: '#00C5BD',
                    left: 241.94,
                    top: 0,
                },
                {
                    text: '구성',
                    left: 446.78,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1326',
            tag: 'p',
            left: 245.7832,
            top: 1504.9443,
            width: 182,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '단계별 윙크 수학',
                    left: 0.2028,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1328',
            tag: 'p',
            left: 569.8296,
            top: 1504.9443,
            width: 128,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '연산력 강화',
                    left: 0.4504,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1330',
            tag: 'p',
            left: 851.9221,
            top: 1504.9443,
            width: 158,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '초등 준비 학습',
                    left: 0.3079,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1327',
            tag: 'p',
            left: 286.8867,
            top: 1543.0283,
            width: 99,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '1~5단계',
                    left: 0.0043,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1329',
            tag: 'p',
            left: 580.9424,
            top: 1543.0283,
            width: 104,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '3~5단계',
                    left: 0.1776,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1331',
            tag: 'p',
            left: 878.5405,
            top: 1543.0283,
            width: 103,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '개념 수학',
                    left: 0.0495,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1322',
            tag: 'p',
            left: 172,
            top: 1665,
            width: 916,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 수학은 적절한 시기에 수학의 기초를 쌓고, 수학을 친근하게 느끼며 생활 속에서 수학적 사고를 하는 아이로',
                    left: 30,
                    top: 0,
                },
                {
                    text: '성장하게 도와줍니다.',
                    left: 30,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1323',
            tag: 'p',
            left: 172,
            top: 1757,
            width: 916,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '수학의 6대 영역인 ‘분류와 순서, 수와 셈, 공간과 도형, 측정, 규칙성, 확률과 통계\'등 체계적으로 배우며 연산력 강화',
                    left: 30,
                    top: 0,
                },
                {
                    text: '연습을 병행합니다.',
                    left: 30,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1324',
            tag: 'p',
            left: 172,
            top: 1849,
            width: 916,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '입학 전, 초등 준비 학습 프로그램을 통해 학교 진도와 동일한 교과학습을 미리 공부할 수 있어 입학 후, 학교 학습에',
                    left: 30,
                    top: 0,
                },
                {
                    text: '쉽게 적응할 수 있습니다.',
                    left: 30,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1313',
            tag: 'h2',
            left: 308.9995,
            top: 2098,
            width: 634,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 수학∙연산 학습 흐름',
                    left: 0.1305,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1309',
            tag: 'p',
            left: 130.0254,
            top: 2256.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '즐겁게',
                    left: 30.6526,
                    top: 0,
                },
                {
                    text: '배워요',
                    left: 30.6526,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1310',
            tag: 'p',
            left: 419.3105,
            top: 2256.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '스스로',
                    left: 30.6595,
                    top: 0,
                },
                {
                    text: '익혀요',
                    left: 30.6595,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1311',
            tag: 'p',
            left: 703.5957,
            top: 2256.8691,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '학습지를',
                    left: 17.6843,
                    top: 0,
                },
                {
                    text: '풀어요',
                    left: 30.6543,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1312',
            tag: 'p',
            left: 994.8809,
            top: 2257.2617,
            width: 139.0927,
            height: 85.6822,
            lineHeight: 39,
            runs: [
                {
                    text: '함께',
                    left: 43.6091,
                    top: 0,
                },
                {
                    text: '확인해요',
                    left: 17.6891,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1279',
            tag: 'h2',
            left: 264,
            top: 2594,
            width: 724,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '즐겁게',
                    left: 252.02,
                    top: 0,
                },
                {
                    text: ' 배워요',
                    color: '#1D1D1D',
                    left: 357.61,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#00B0B6',
        },
        {
            key: '2019:1280',
            tag: 'p',
            left: 264,
            top: 2648,
            width: 724,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '흥미롭고 자연스럽게 수학의 6대 영역을 골고루, 수학적 사고의 토대를 탄탄히!',
                    left: 0.266,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1282',
            tag: 'h3',
            left: 259,
            top: 2974,
            width: 294,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '재미있는 수학(애니)',
                    left: 51.891,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1285',
            tag: 'h3',
            left: 676,
            top: 2974,
            width: 329,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '생활 속 수학(동영상)',
                    left: 66.62,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1283',
            tag: 'p',
            left: 259,
            top: 3011,
            width: 294,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '스토리텔링 애니메이션으로 수학적 개념을',
                    left: 0.398,
                    top: 0,
                },
                {
                    text: ' 쉽고 재미있게 깨우칩니다',
                    left: 54.847,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1286',
            tag: 'p',
            left: 676,
            top: 3011,
            width: 329,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '학습한 내용이 생활 속에서 어떤 모습으로',
                    left: 21.28,
                    top: 0,
                },
                {
                    text: '존재하는지 살펴보며 살아있는 지식을 배웁니다',
                    left: 0.14,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1270',
            tag: 'h2',
            left: 204,
            top: 3227,
            width: 854,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '스스로 ',
                    left: 317.02,
                    top: 0,
                },
                {
                    text: '익혀요',
                    color: '#1D1D1D',
                    left: 431.39,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#00B0B6',
        },
        {
            key: '2019:1271',
            tag: 'p',
            left: 204,
            top: 3281,
            width: 854,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '학습게임과 확인 학습을 통해 실력을 다지고 틀린문제는 반복학습을 통해 완벽히 이해합니다.',
                    left: 0.438,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1273',
            tag: 'h3',
            left: 283,
            top: 3618,
            width: 251,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '놀이로 수학',
                    left: 70.88,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1276',
            tag: 'h3',
            left: 661,
            top: 3618,
            width: 358,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '딩동댕 정리하기',
                    left: 103.64,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1274',
            tag: 'p',
            left: 283,
            top: 3655,
            width: 251,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '학습한 내용을 놀이를 통해 반복하고',
                    left: 0.036,
                    top: 0,
                },
                {
                    text: '수학적 스킬까지 재미있게 얻어요',
                    left: 10.012,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1277',
            tag: 'p',
            left: 661,
            top: 3655,
            width: 358,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '퀴즈 또는 문제를 풀어보며 하루의 학습을 점검해요.',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1291',
            tag: 'h2',
            left: 205,
            top: 3869,
            width: 859,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '학습지를',
                    left: 301.92,
                    top: 0,
                },
                {
                    text: ' 풀어요',
                    color: '#1D1D1D',
                    left: 442.7,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#00B0B6',
        },
        {
            key: '2019:1292',
            tag: 'p',
            left: 205,
            top: 3923,
            width: 859,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '손으로 직접 쓰면서 풀면, 진정한 자기 실력이 됩니다.',
                    left: 184.95,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1288',
            tag: 'h3',
            left: 294,
            top: 4263,
            width: 225,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '수준별 수학 학습지 풀기',
                    left: 0.492,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1294',
            tag: 'h3',
            left: 653,
            top: 4263,
            width: 374,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '학습지를 풀다가 모르는 문제가 나오면?',
                    left: 3.54,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1289',
            tag: 'p',
            left: 306.5,
            top: 4300,
            width: 200,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '매월 제공되는 학습지를 풀며',
                    left: 0.068,
                    top: 0,
                },
                {
                    text: '완전히 내 것으로 만들어요',
                    left: 7.847,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1295',
            tag: 'p',
            left: 653,
            top: 4300,
            width: 374,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '버튼 하나만 누르면 선생님 풀이 영상이 바로 재생되어',
                    left: 0.5,
                    top: 0,
                },
                {
                    text: '스스로 문제를 해결할 수 있어요',
                    left: 77.09,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1303',
            tag: 'h2',
            left: 195,
            top: 4514,
            width: 859,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '선생님 또는 부모님과 ',
                    left: 147.957,
                    top: 0,
                },
                {
                    text: '함께 확인해요',
                    color: '#1D1D1D',
                    left: 491.08,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#00B0B6',
        },
        {
            key: '2019:1304',
            tag: 'p',
            left: 195,
            top: 4568,
            width: 859,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '배운 내용을 선생님 또는 학부모님과 함께 확인하니까 더 오랫동안 기억할 수 있습니다.',
                    left: 31.121,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1300',
            tag: 'h3',
            left: 273,
            top: 4917,
            width: 267,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '선생님과 함께 확인',
                    left: 45,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1297',
            tag: 'h3',
            left: 662,
            top: 4917,
            width: 356,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '부모님과 함께 확인',
                    left: 89.5,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1301',
            tag: 'p',
            left: 273,
            top: 4954,
            width: 267,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '선생님의 실시간 코칭으로 배운 내용을',
                    left: 0.258,
                    top: 0,
                },
                {
                    text: '한 번 더 이야기하며 확인해요.',
                    left: 28.998,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1298',
            tag: 'p',
            left: 662,
            top: 4954,
            width: 356,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '전체 학습 현황과 틀린 문제를 쉽게  확인할 수 있고,',
                    left: 0.25,
                    top: 0,
                },
                {
                    text: '틀린 문제는 클릭 한 번으로 재학습할 수 있어요.',
                    left: 12.46,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1264',
            tag: 'h2',
            left: 291,
            top: 5219,
            width: 678,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '윙크 수준별 수학 단계별 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '커리큘럼',
                    color: '#00B0B6',
                    left: 387.11,
                    top: 0,
                },
                {
                    text: ' 상세보기',
                    left: 527.89,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1261',
            tag: 'p',
            left: 384,
            top: 5365,
            width: 492,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '초등 1~2학년 때의 수학은 너무 쉬워서 기본 계산력 형성을 위한',
                    left: 0.1017,
                    top: 0,
                },
                {
                    text: '체계적인 학습량이 절대적으로 부족합니다.',
                    left: 80.475,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#565656',
        },
        {
            key: '2019:1262',
            tag: 'p',
            left: 268,
            top: 5458,
            width: 724,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '이렇게 학습할 경우, 갑자기 학습량과 난이도 올라가는 3학년부터의 수학을 탄탄하게 대비하기',
                    left: 0.3592,
                    top: 0,
                },
                {
                    text: '어렵기 때문에 수준별 학습을 통해 학습 공백 없이 충분하게 익혀 놓아야 합니다.',
                    left: 55.945,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#565656',
        },
        {
            key: '2019:1263',
            tag: 'h3',
            left: 385,
            top: 5551,
            width: 491,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 수학 5단계까지 학습할 경우',
                    left: 117.825,
                    top: 0,
                },
                {
                    text: '초등 4학년 수준까지 커버 할 수 있으므로 초등 교과 수준은 물론',
                    left: 0.3925,
                    top: 28,
                },
                {
                    text: '기초에서 심화학습까지 충분히 대비할 수 있습니다.',
                    left: 49.9083,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 800,
            color: '#00B0B6',
        },
        {
            key: '2019:1237',
            tag: 'h2',
            left: 318,
            top: 5852,
            width: 623,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 수학',
                    left: 0.123,
                    top: 0,
                },
                {
                    text: '∙',
                    left: 330.05,
                    top: 0,
                },
                {
                    text: '연산 커리큘럼',
                    left: 347.93,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1256',
            tag: 'p',
            left: -89,
            top: 5949.999,
            width: 87,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '안녕 수학 단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1255',
            tag: 'p',
            left: 194,
            top: 5949.999,
            width: 65,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '수학 1단계',
                    left: 0.427,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1254',
            tag: 'p',
            left: 462,
            top: 5949.999,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '수학 2단계',
                    left: 0.31,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1251',
            tag: 'p',
            left: 1273,
            top: 5949.999,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '수학 5단계',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1252',
            tag: 'p',
            left: 1003,
            top: 5950,
            width: 68,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '수학 4단계',
                    left: 0.41,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1253',
            tag: 'p',
            left: 733,
            top: 5950.3916,
            width: 67,
            height: 29,
            lineHeight: 29,
            letterSpacing: '-0.03em',
            runs: [
                {
                    text: '수학 3단계',
                    left: 0.08,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1248',
            tag: 'h3',
            left: -115,
            top: 6010.8691,
            width: 136,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '인지 능력 강화',
                    left: 0.242,
                    top: 0,
                },
                {
                    text: '수학 놀이',
                    left: 23.75,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1239',
            tag: 'h3',
            left: 136,
            top: 6011,
            width: 177,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '본격적인 수학 입문',
                    left: 0,
                    top: 0,
                },
                {
                    text: '수 기초 개념',
                    left: 31.113,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1241',
            tag: 'h3',
            left: 428,
            top: 6011,
            width: 130,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '영역별 수학의',
                    left: 0.01,
                    top: 0,
                },
                {
                    text: '기초 학습',
                    left: 20.75,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1245',
            tag: 'h3',
            left: 967,
            top: 6027.998,
            width: 136,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 수학 심화',
                    left: 0.24,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1247',
            tag: 'h3',
            left: 1236,
            top: 6027.998,
            width: 136,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 수학 강화',
                    left: 0.24,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1243',
            tag: 'h3',
            left: 696,
            top: 6028.3906,
            width: 136,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 수학 준비',
                    left: 0.24,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1249',
            tag: 'p',
            left: -120,
            top: 6086,
            width: 145,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 30~38개월',
                    left: 0.125,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1238',
            tag: 'p',
            left: 153,
            top: 6086,
            width: 143,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 4~5세 적합',
                    left: 0.125,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1240',
            tag: 'p',
            left: 422,
            top: 6086,
            width: 142,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 6~7세 적합',
                    left: 0.28,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1244',
            tag: 'p',
            left: 963,
            top: 6086,
            width: 143,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 8~9세 적합',
                    left: 0.11,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1246',
            tag: 'p',
            left: 1229,
            top: 6086,
            width: 150,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 9~10세 적합',
                    left: 0.04,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1242',
            tag: 'p',
            left: 693,
            top: 6086.3926,
            width: 142,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 7~8세 적합',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1229',
            tag: 'h3',
            left: 575,
            top: 6365,
            width: 114,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '안녕 수학 단계',
                    left: 0.26,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1230',
            tag: 'p',
            left: 498,
            top: 6395,
            width: 268,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '인지 능력 강화 수학 놀이',
                    left: 0.48,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1231',
            tag: 'p',
            left: 178,
            top: 6770,
            width: 808,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 안녕 수학 단계는 논리와 사고력이 필요한 수학적 개념을 다루기에 앞서 모든 학습의 기초가 되는',
                    left: 30,
                    top: 0,
                },
                {
                    text: '인지 능력을 강화하기 위해 다양한 놀이',
                    color: '#008983',
                    left: 29.297,
                    top: 28,
                },
                {
                    text: '를 진행합니다.',
                    left: 330.27,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1232',
            tag: 'p',
            left: 178,
            top: 6851,
            width: 906,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '아이 눈높이에 맞춘 흥미로운 스토리의 애니메이션으로 주요 개념을 접하고 이야기에 직접 개입하여 문제를 해결해',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      나가며, 이 과정에서 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '자기 효능감',
                    color: '#008983',
                    left: 187.36,
                    top: 28,
                },
                {
                    text: '을 느끼고 ',
                    left: 278.67,
                    top: 28,
                },
                {
                    text: '학습에 대한 자신감을 향상',
                    color: '#008983',
                    left: 357.58,
                    top: 28,
                },
                {
                    text: '시킬 수 있습니다.',
                    left: 562.36,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1233',
            tag: 'p',
            left: 178,
            top: 6932,
            width: 860,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '다양한 유형으로 구성된 인터랙션 활동을 통해 개념을 확고히 하며, 반복되는 유형을 배제하여 매회차 새로운',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      활동을 진행합니다. 안녕 수학 12주 과정을 통해 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '윙크 수준별 수학 학습에 필요한 기초적인 이해력과 사고력,',
                    color: '#008983',
                    left: 400.51,
                    top: 28,
                },
                {
                    text: '      전반적인 인지 능력을 향상시킬 수 있습니다.',
                    color: '#008983',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1225',
            tag: 'h3',
            left: 533,
            top: 7151,
            width: 187,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '수학 1단계 (수학 입문 I)',
                    left: 0.42,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1226',
            tag: 'p',
            left: 453,
            top: 7181,
            width: 346,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '본격적인 수학 입문 수 기초 개념',
                    left: 0.05,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1222',
            tag: 'h3',
            left: 476,
            top: 7250,
            width: 300,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 1학년 1학기 교과 수준 포함',
                    left: 0.47,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1220',
            tag: 'p',
            left: 173,
            top: 7594,
            width: 889,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '초등 수학 1학년 1학기를 수월하게 대비할 수 있는 1~10까지 수 쓰기와 수량 개념, 수의 크기 비교를 통해',
                    left: 30,
                    top: 0,
                },
                {
                    text: '수에 대한 기초 개념',
                    color: '#008983',
                    left: 29.297,
                    top: 28,
                },
                {
                    text: '을 익히고, 크기나 두께나 무게, 넓이 등의 비교로 분류와 측정을 배울 뿐만 아니라 모양, 크기',
                    left: 182.23,
                    top: 28,
                },
                {
                    text: '      색깔의 반복 규칙과 추론을 통해 ',
                    left: 0,
                    top: 56,
                },
                {
                    text: '논리적 학습의 기초를 다지는 단계입니다.',
                    color: '#008983',
                    left: 278.42,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1221',
            tag: 'p',
            left: 173,
            top: 7703,
            width: 916,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '아울러 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '연필을 바르게 쥐고 선을 긋는 운필력',
                    color: '#008983',
                    left: 86.738,
                    top: 0,
                },
                {
                    text: ' 학습은 시각 데이터를 받아들이는 뇌의 인지 능력과 소근육의 협응력을',
                    left: 370.43,
                    top: 0,
                },
                {
                    text: '      발달시켜 수학뿐만 아니라 모든 학습 영역에 도움을 줄 수 있습니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1214',
            tag: 'h3',
            left: 529,
            top: 7893.2922,
            width: 195,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '수학 2단계 (수학 입문 II)',
                    left: 0.45,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1215',
            tag: 'p',
            left: 495.5,
            top: 7923.2922,
            width: 261,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '영역별 수학의 기초 학습',
                    left: 0.11,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1219',
            tag: 'h3',
            left: 506,
            top: 7997,
            width: 241,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 1학년 교과 수준 포함',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1216',
            tag: 'p',
            left: 172,
            top: 8336,
            width: 898,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 수학 2단계에서는 구체물과 반구체물을 활용한 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '모으기와 가르기 학습',
                    color: '#008983',
                    left: 434.16,
                    top: 0,
                },
                {
                    text: '을 하며, 수의 원리를 익히고',
                    left: 599.49,
                    top: 0,
                },
                {
                    text: '      덧셈과 뺄셈의 기초 개념을 이해할 수 있는 활동을 합니다. 이어서 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '두 자릿수에 대한 개념을 정립하고 30까지의 수',
                    color: '#008983',
                    left: 532.6,
                    top: 28,
                },
                {
                    text: '      를 읽고, 쓰며 수량적 개념도 익히게 됩니다.',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1217',
            tag: 'p',
            left: 172,
            top: 8445,
            width: 756,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '아울러 기준에 따라 순서 짓는 규칙성 활동을 바탕으로 한 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '수학적 추론 능력',
                    color: '#008983',
                    left: 471.5,
                    top: 0,
                },
                {
                    text: ' 학습을 시작합니다.',
                    left: 602.27,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1218',
            tag: 'p',
            left: 172,
            top: 8498,
            width: 903,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '주변에서 볼 수 있는 다양한 사물을 활용하여 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '2차원 도형',
                    color: '#008983',
                    left: 375.31,
                    top: 0,
                },
                {
                    text: '의 기초 개념을 익혀 나가고 입체 도형 학습의 기초가 되는',
                    left: 461.21,
                    top: 0,
                },
                {
                    text: '공간 지각 활동도 병행합니다.',
                    color: '#008983',
                    left: 29.297,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1203',
            tag: 'h3',
            left: 572.5,
            top: 8689,
            width: 87,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '수학 3단계',
                    left: 0.25,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1204',
            tag: 'p',
            left: 536,
            top: 8719,
            width: 158,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '초등 수학 준비',
                    left: 0.14,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1200',
            tag: 'h3',
            left: 480,
            top: 8788,
            width: 271,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 1~2학년 교과 수준 포함',
                    left: 0.18,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1197',
            tag: 'p',
            left: 156,
            top: 9137,
            width: 936,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 수학 3단계에서는 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '100까지의 수',
                    color: '#008983',
                    left: 212.7,
                    top: 0,
                },
                {
                    text: '를 익히고, ',
                    left: 320.33,
                    top: 0,
                },
                {
                    text: '10씩 묶어 세는 연습',
                    color: '#008983',
                    left: 404.38,
                    top: 0,
                },
                {
                    text: '을 하며 ',
                    left: 561.31,
                    top: 0,
                },
                {
                    text: '세 자릿수와 자릿값에 대한 ',
                    color: '#008983',
                    left: 622.93,
                    top: 0,
                },
                {
                    text: '      기초 개념',
                    color: '#008983',
                    left: 0,
                    top: 28,
                },
                {
                    text: '을 학습합니다. 또한 길이와 넓이, 무게 등에 대한 비교를 위해 ',
                    left: 103.32,
                    top: 28,
                },
                {
                    text: '비표준화된 단위',
                    color: '#008983',
                    left: 577.19,
                    top: 28,
                },
                {
                    text: '를 활용하는 학습을 병행하고, ',
                    left: 703.07,
                    top: 28,
                },
                {
                    text: '      시각과 시간의 개념도 함께 학습합니다.',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1198',
            tag: 'p',
            left: 156,
            top: 9246,
            width: 741,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '아울러 받아 올림이나 받아내림이 없는 범위 내에서의 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '덧셈과 뺄셈을 본격적으로 학습',
                    color: '#008983',
                    left: 444.45,
                    top: 0,
                },
                {
                    text: '합니다. ',
                    left: 683.81,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1199',
            tag: 'p',
            left: 156,
            top: 9299,
            width: 943,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '이미 습득된 기초 도형에 대한 개념을 바탕으로 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '도형 추론 학습',
                    color: '#008983',
                    left: 392.6,
                    top: 0,
                },
                {
                    text: '도 진행함으로써, 유아는 초등 저학년 수준의 수학 학습을',
                    left: 506.07,
                    top: 0,
                },
                {
                    text: '      완벽히 대비 할 수 있습니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1190',
            tag: 'h3',
            left: 566,
            top: 9489,
            width: 87,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '수학 4단계',
                    left: 0.14,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1191',
            tag: 'p',
            left: 530,
            top: 9519,
            width: 158,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '초등 수학 심화',
                    left: 0.14,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1192',
            tag: 'h3',
            left: 471,
            top: 9590,
            width: 276,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 2~3학년 교과 수준 포함',
                    left: 0.45,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1193',
            tag: 'p',
            left: 154,
            top: 9937,
            width: 798,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 수학 4단계에서는 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '받아올림과 받아내림이 있는 두 자릿수 이상의 덧셈과 뺄셈',
                    color: '#008983',
                    left: 212.89,
                    top: 0,
                },
                {
                    text: ' 학습을 시작으로 ',
                    left: 661.91,
                    top: 0,
                },
                {
                    text: '곱셈 연산 학습을 시작합니다.',
                    color: '#008983',
                    left: 29.297,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1194',
            tag: 'p',
            left: 154,
            top: 10018,
            width: 864,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '많은 유아들이 어려워하는 문장을 통해 문제 상황을 인지하고 식을 세워 답을 구하는 문장제 학습과 이를 통해',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      미지수를 구하는 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '방정식의 기초 개념',
                    color: '#008983',
                    left: 160.059,
                    top: 28,
                },
                {
                    text: '도 함께 습득합니다.',
                    left: 308.11,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1195',
            tag: 'p',
            left: 154,
            top: 10099,
            width: 820,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '단위 환산을 이용하여 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '길이와 시간의 합과 차를 구하는 측정 영역의 응용 학습',
                    color: '#008983',
                    left: 200.21,
                    top: 0,
                },
                {
                    text: '까지 진행함으로써 수학의',
                    left: 619.55,
                    top: 0,
                },
                {
                    text: '      각 영역별 확장개념을 익히고, 좀 더 높은 수준의 문제 해결력을 기릅니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1184',
            tag: 'h3',
            left: 566,
            top: 10288,
            width: 87,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '수학 5단계',
                    left: 0.42,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1185',
            tag: 'p',
            left: 530,
            top: 10318,
            width: 158,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '초등 수학 강화',
                    left: 0.14,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1186',
            tag: 'h3',
            left: 471,
            top: 10387,
            width: 277,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 3~4학년 교과 수준 포함',
                    left: 0.34,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1187',
            tag: 'p',
            left: 155,
            top: 10736,
            width: 884,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '초등 3학년 내용으로 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '받아올림/내림이 있는 세 자릿수까지의 덧/뺄셈과 곱셈, 나눗셈을 학습',
                    color: '#008983',
                    left: 195.41,
                    top: 0,
                },
                {
                    text: '할 뿐 아니라,',
                    left: 732.54,
                    top: 0,
                },
                {
                    text: '      분수와 소수의 개념을 익히고',
                    color: '#008983',
                    left: 0,
                    top: 28,
                },
                {
                    text: ' 동분모 분수의 덧뺄셈까지 학습하면서 ',
                    left: 251.37,
                    top: 28,
                },
                {
                    text: '초등 수학의 기초적인 사칙연산과 수개념을',
                    color: '#008983',
                    left: 552.34,
                    top: 28,
                },
                {
                    text: '      마스터하는 과정',
                    color: '#008983',
                    left: 0,
                    top: 56,
                },
                {
                    text: '입니다.',
                    left: 155.176,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1206',
            tag: 'p',
            left: 363.5,
            top: 10995,
            width: 506,
            height: 45,
            lineHeight: 45,
            runs: [
                {
                    text: '윙크 수준별 영어 & 파닉스 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '보러 가기',
                    color: '#FFBACE',
                    left: 374.71,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 35,
            weight: 800,
            color: 'white',
        },
    ],
    label: '수학·연산',
    frame: '2019:1177',
    heading: '2019:1346',
    link: {
        key: '2019:1206',
        left: 301.5,
        top: 10970,
        width: 658,
        height: 95,
        href: '/subject/en',
        id: 'subject-math-en-button',
    },
    animations: [],
    decorationShift: {
        top: 2439,
        by: -2,
    },
};
